/**
 * Shared inventory/variant override rules for CLP + Search cards.
 *
 * Keep all hardcoded handle mappings in one place so behavior stays in sync.
 */
(function (window) {
  'use strict';

  const FIXED_TARGET_PRODUCT_ID_BY_HANDLE = Object.freeze({
    'epic-tray-6-cell-germination-dome-and-bottom-tray': 8472516296900,
    'epic-tray-4-cell-germination-dome-and-bottom-tray': 8472490016964,
    'ultimate-beginner-seed-starting-bundle': 7922886115524,
    '3-cube-pot': 8500111900868,
  });

  // Handles where card/search inventory is driven by mapped/virtual bundle logic.
  const INVENTORY_OVERRIDE_HANDLES = new Set([
    'epic-tray-6-cell-germination-dome-and-bottom-tray',
    'epic-tray-4-cell-germination-dome-and-bottom-tray',
    'ultimate-beginner-seed-starting-bundle',
    '3-cube-pot',
    'epic-16-cell-seed-starting-trays',
    '29-tall-birdies-large-4pack',
    '15-short-birdies-large-4pack',
    '29-tall-birdies-medium-4pack',
    '15-short-birdies-medium-4pack',
    '29-tall-birdies-small-4pack',
    '15-short-birdies-small-4pack',
  ]);

  function normalizeHandle(handle) {
    return String(handle || '').trim();
  }

  function shouldApplyInventoryOverride(handle) {
    return INVENTORY_OVERRIDE_HANDLES.has(normalizeHandle(handle));
  }

  function shouldApplyVirtualBundleOverwrite(handle) {
    // Keep virtual bundle overwrite rules aligned with inventory override rules.
    return shouldApplyInventoryOverride(handle);
  }

  function getFixedMappedTargetProductId(handle) {
    const normalized = normalizeHandle(handle);
    return FIXED_TARGET_PRODUCT_ID_BY_HANDLE[normalized] || null;
  }

  window.EGInventoryOverrides = Object.freeze({
    shouldApplyInventoryOverride,
    shouldApplyVirtualBundleOverwrite,
    getFixedMappedTargetProductId,
  });
})(window);
